import { useContext, useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { TableRefreshContext } from '../../context/TableRefreshContext';
import useTable from '../../hooks/useTable';
import { HoverDropDown } from '../DropDown/DropDown';
import FilterIcon from '../Icons/FilterIcon';
import { FormFilter } from './FormFilter';
import { Table } from './Table';
import TableSearchFormField from './TableSearchFormField';
import { composeTableFilterUri } from './tableTools';

interface ImappingData {
  [key: string]: string;
}

interface ITableComponent {
  mappingData?: ImappingData;
  tableBaseUrl: string;
  tableHeader: string[];
  tableExtraQueryParams?: string;
  cellNavigation?: (...args: any[]) => void;
  rigthRevealComponent?: (...args: any[]) => React.ReactNode;
  filterData: any;
  tblSearhURI?: string;
}

interface ITableFilterButton {
  children: any;
}

const TableFilterButton: React.FC<ITableFilterButton> = ({ children }) => {
  return <TableFilterButtonLabel>{children}</TableFilterButtonLabel>;
};

export const TableComponent: React.FC<ITableComponent> = ({
  tableBaseUrl,
  tableHeader,
  tableExtraQueryParams,
  mappingData,
  tblSearhURI,
  cellNavigation,
  rigthRevealComponent,
  filterData,
}) => {
  const refreshTableContext = useContext(TableRefreshContext);
  const { endPage, tableData, loading, setLoading, fetchTableData } =
    useTable();

  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState('Select a filter');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setPage(1);
  }, [filter]);

  useEffect(() => {
    const itemsPerPage = 10;
    let tblUri = `${tableBaseUrl}?page=${page - 1}&size=${itemsPerPage}`;
    // console.log('filter???>>', filter);
    if (filter === 'Select a filter') {
      if (tableExtraQueryParams) {
        tblUri = tblUri + '&' + tableExtraQueryParams;
      }
      fetchTableData(tblUri);
    }
    // TODO:: come and review latter
    else if (filter === 'enabled' && searchQuery.trim() !== '') {
      let searchP = '';
      if (searchQuery.trim().toLowerCase() === 'active') {
        searchP = 'true';
      } else if (searchQuery.trim().toLowerCase() === 'inactive') {
        searchP = 'false';
      }
      tblUri = `${tblSearhURI}?page=${page - 1}&size=${itemsPerPage}`;
      tblUri = composeTableFilterUri(tblUri, searchP, filter);
      fetchTableData(tblUri);
    } else if (filter && searchQuery.trim() !== '') {
      tblUri = `${tblSearhURI}?page=${page - 1}&size=${itemsPerPage}`;
      tblUri = composeTableFilterUri(tblUri, searchQuery.trim(), filter);
      fetchTableData(tblUri);
    }

    // eslint-disable-next-line
  }, [page, filter, searchQuery, refreshTableContext?.refreshTable]);

  return (
    <TableContainer>
      <TableToolBox>
        <TableSearchFormField
          setSearchQuery={setSearchQuery}
          searchPlaceHolder={filter}
        />
        <HoverDropDown
          label={
            <TableFilterButton>
              <FilterIcon /> Filter
            </TableFilterButton>
          }
        >
          {
            <FormFilter
              filter={filter}
              filterData={{ ...filterData, Reset: 'Select a filter' }}
              setFilter={setFilter}
            />
          }
        </HoverDropDown>
      </TableToolBox>
      <Table
        showTableLoadingIcon={loading}
        setShowTableLoadingIcon={setLoading}
        rigthRevealComponent={rigthRevealComponent}
        page={page}
        endPage={endPage}
        tData={tableData}
        clickLeft={() => setPage(page === 0 ? page : page - 1)}
        clickRight={() => setPage(endPage > page ? page + 1 : page)}
        tableHeader={tableHeader}
        mappingData={mappingData}
        cellNavigation={cellNavigation}
      />
    </TableContainer>
  );
};

const TableContainer = styled.div`
  display: grid;
  gap: 1.5rem;

  @media screen and (max-width: 480px) {
    overflow-x: auto;
  }
`;

const TableToolBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TableFilterButtonLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.62rem;
  height: 48px;
  font-weight: 500;
  padding: 1rem 2rem;
  background-color: white;
  color: '#867C79';
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.palette.brandGrey};
`;
